/**
 * The Library search box's own syntax on top of Postgres websearch:
 * `tag:name` (or `tag:"two words"`) filters by tag instead of searching the
 * word. Everything else — plain words, "quotes", OR, -word — goes to the
 * full-text search untouched. Board task #29.
 */

// Mirrors Django's django.utils.text.slugify, which made every tag slug
// (knowledge/enrichment.py), so `tag:Machine Learning` finds the
// `machine-learning` tag.
export const slugify = (value) =>
  value
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/[-\s]+/g, "-")
    .replace(/^[-_]+|[-_]+$/g, "");

// `tag:` at the start or after whitespace (so `-tag:x` and `mytag:x` are left
// alone), then a quoted phrase or a run of non-space characters — possibly
// none: a bare `tag:` is dropped rather than searched for as a word.
const TAG_TOKEN = /(^|\s)tag:(?:"([^"]*)"|(\S*))/gi;

/**
 * Split raw search input into the text query and the tag slugs.
 * @param {string} input
 * @returns {{ q: string, tags: string[] }}
 */
export const parseSearchInput = (input) => {
  const tags = [];
  const q = (input || "")
    .replace(TAG_TOKEN, (_, lead, quoted, bare) => {
      const slug = slugify(quoted ?? bare);
      if (slug && !tags.includes(slug)) tags.push(slug);
      return lead;
    })
    .replace(/\s+/g, " ")
    .trim();
  return { q, tags };
};
